// @ts-check

/**
 * Tiny runtime-safe source of truth for the neutral Web builder contract.
 * Keeping this file dependency-free lets native Node template generators and
 * TypeScript bundlers consume the tuple without pulling renderer descriptors
 * into the neutral graph. Shop deliberately owns a narrower compatibility
 * subset in shopVerticalCatalog.ts.
 */
export const SITE_NAVIGATION_VARIANTS = /** @type {const} */ ([
    "departmentMega",
    "audienceMega",
    "editorialOverlay",
    "roomPlanner",
    "routineMega",
    "collectionConcierge",
    "groceryHub",
    "productStory",
    "categoryPills",
    "technicalIndex",
    "lagunaClassic",
    "borderedDropdown",
    "imageCategoryStrip",
    "monochromeDropdown",
    "industrialBar",
    "cinematicOverlay",
    "minimalReveal",
    "boldUnderline",
    "editorialRule",
    "playfulFrame",
    "neonLine",
]);

/**
 * Curated treatments offered by the Web builder. Keep the wider catalog above
 * intact so already-persisted Web and Shop variants remain runtime-compatible.
 */
export const WEB_NAVIGATION_VARIANTS = /** @type {const} */ ([
    "minimalReveal",
    "boldUnderline",
    "editorialRule",
    "playfulFrame",
    "neonLine",
]);
